/* eslint-disable react/no-unescaped-entities */
import { Routes, Route, Link } from "react-router-dom";
import React, { useEffect } from "react";
import App from "./App";
import Layout from "./components/Layout";
import ScrollToAnchor from "./ScrollToAnchor";
import ProjectById from "./Pages/ProjectById";
import OutsourcedById from "./Pages/OutsourcedById";

import Lights from './assets/animations/lights.mp4'
import PropertyBrothers from './assets/animations/propertyBrothers.mp4'
import TimeLapse from './assets/animations/timelapse.mp4'

export default function Router() {
  return (
    <>
      <ScrollToAnchor/>
      <Routes>
        <Route index element={ <Layout>
          <App />
        </Layout> } />
        <Route path="tour-360" element={<Layout>
          <About />
        </Layout>} />
        <Route path="/project/:id" element={
          <Layout withFooter={false}>
            <ProjectById />        
          </Layout>} />
        <Route path="/outsourced/:id" element={
          <Layout withFooter={false}>
            <OutsourcedById />        
          </Layout>} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </>
  );
}

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  },[])
  return (
    <div style={{display: 'flex', alignItems: "center", flexDirection: 'column'}}>
      <h1 style={{marginLeft: '5%', alignSelf: 'flex-start'}}>Tour 360</h1>
      <iframe  style={{width: '70%'}} width="100%" height="640" frameBorder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://kuula.co/share/collection/7ZKPz?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=0"></iframe>   
      <h1 style={{marginLeft: '5%',marginTop: '5%', alignSelf: 'flex-start'}}>Animações</h1>
      <h2 style={{marginLeft: '7%',marginTop: '5%', alignSelf: 'flex-start'}}>Luzes</h2>

      <video  style={{maxWidth: '95%'}} controls >
        <source src={Lights} type="video/mp4"/>
      </video>
      <h2 style={{marginLeft: '7%',marginTop: '5%', alignSelf: 'flex-start'}}>Cameras</h2>

      <video  style={{maxWidth: '95%'}} controls >
        <source src={TimeLapse} type="video/mp4"/>
      </video>
      <h2 style={{marginLeft: '7%',marginTop: '5%', alignSelf: 'flex-start'}}>Ações</h2>
      <video  controls  style={{maxWidth: '95%',marginBottom: '5vh'}} >
        <source src={PropertyBrothers} type="video/mp4"/>
      </video>
    </div>
  );
}


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}